import React from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import ReactEcharts from "echarts-for-react"
import getChartColorsArray from "components/Common/ChartsDynamicColor"

const PieChart = props => {
  const {
    colors,
    dataLabels,
    dataValues,
    name,
    radius,
    centerX,
    centerY,
    height,
  } = props
  const PieEChartColors = getChartColorsArray(colors)
  const options = {
    toolbox: {
      show: false,
    },
    tooltip: {
      trigger: "item",
      formatter: function (params) {
        return `${params.name}<br />
          Quantidade: ${params.data.value} (${params.percent}%)<br />`
      },
    },
    legend: {
      orient: "vertical",
      left: "left",
      data: dataLabels,
      textStyle: {
        color: ["#8791af"],
      },
    },
    color: PieEChartColors,
    series: [
      {
        name: name,
        type: "pie",
        radius: radius,
        center: [centerX, centerY],
        data: dataValues,
        avoidLabelOverlap: true,
        label: {
          position: "outter",
          alignTo: "labelLine",
          formatter: function (params) {
            return `${params.percent}%`
          },
          margin: 20,
        },
        // label: {
        //     show: false,
        //   },
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  }
  return (
    <React.Fragment>
      <ReactEcharts style={{ height: height }} option={options} />
    </React.Fragment>
  )
}

PieChart.propTypes = {
  t: PropTypes.any,
  colors: PropTypes.string,
  dataLabels: PropTypes.array,
  dataValues: PropTypes.array,
  name: PropTypes.string,
  radius: PropTypes.string,
  centerX: PropTypes.string,
  centerY: PropTypes.string,
  height: PropTypes.string,
}

export default withTranslation()(PieChart)
